export function applyBasketState(basket, type) {
    basket.querySelectorAll('.basket-fly__tabs li').forEach((tab) => {
        tab.classList.toggle('basket-fly__tab_active', tab.dataset.type === type);
    });
    basket.querySelectorAll('.tabs_content.basket > li').forEach((content) => {
        content.classList.toggle('basket-fly__content_active', content.getAttribute('item-section') === type);
    });
    basket.querySelectorAll('.edge-menu__item').forEach((item) => {
        item.classList.toggle('edge-menu__item--active', item.dataset.type === type);
    });
    basket.querySelectorAll('.remove_all_basket').forEach((button) => {
        const buttonType = button.classList.contains('AnDelCanBuy')
            ? 'AnDelCanBuy'
            : button.classList.contains('DelDelCanBuy')
              ? 'DelDelCanBuy'
              : button.classList.contains('nAnCanBuy')
                ? 'nAnCanBuy'
                : null;

        button.classList.toggle('remove_all_basket--active', buttonType === type);
    });
}
